import { render } from "./FactorListItem.vue?vue&type=template&id=074fca44"
import script from "./FactorListItem.vue?vue&type=script&lang=js"
export * from "./FactorListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__